import { render, staticRenderFns } from "./Wholesale.vue?vue&type=template&id=337e3b4f&"
import script from "./Wholesale.vue?vue&type=script&lang=js&"
export * from "./Wholesale.vue?vue&type=script&lang=js&"
import style0 from "./Wholesale.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports